import { render, staticRenderFns } from "./CustomerReturns.vue?vue&type=template&id=458d26bc&"
import script from "./CustomerReturns.vue?vue&type=script&lang=js&"
export * from "./CustomerReturns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports